import script from "./PrenotaAppuntamento.vue?vue&type=script&setup=true&lang=js"
export * from "./PrenotaAppuntamento.vue?vue&type=script&setup=true&lang=js"

import "./PrenotaAppuntamento.vue?vue&type=style&index=0&id=66b63818&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b63818"]])

export default __exports__